"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var NotificationAnnouncementStore = /*#__PURE__*/function (_RootStore) {
  function NotificationAnnouncementStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, NotificationAnnouncementStore);
    _this = _callSuper(this, NotificationAnnouncementStore);
    _this.config = {
      model: _models.NotificationAnnouncement,
      deserialize: true,
      GET: {
        index: '/notification_announcements',
        show: '/notification_announcements/:notificationAnnouncementId'
      },
      POST: {
        create: '/notification_announcements',
        selectAllMemberships: '/notification_announcements/:notificationAnnouncementId/select_all_memberships',
        testNotification: '/notification_announcements/:notificationAnnouncementId/test_notification'
      },
      PUT: {
        update: '/notification_announcements/:notificationAnnouncementId',
        publish: '/notification_announcements/:notificationAnnouncementId/publish',
        schedule: '/notification_announcements/:notificationAnnouncementId/schedule',
        cancelSchedule: '/notification_announcements/:notificationAnnouncementId/cancel_schedule',
        copy: '/notification_announcements/:notificationAnnouncementId/copy'
      },
      DELETE: {
        destroy: '/notification_announcements/:notificationAnnouncementId',
        clearAllMemberships: '/notification_announcements/:notificationAnnouncementId/clear_all_memberships'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(NotificationAnnouncementStore, _RootStore);
  return (0, _createClass2["default"])(NotificationAnnouncementStore, [{
    key: "publish",
    value: function publish(params, callback) {
      this.api(params, callback, 'PUT', 'publish');
    }
  }, {
    key: "schedule",
    value: function schedule(params, callback) {
      this.api(params, callback, 'PUT', 'schedule');
    }
  }, {
    key: "cancelSchedule",
    value: function cancelSchedule(params, callback) {
      this.api(params, callback, 'PUT', 'cancelSchedule');
    }
  }, {
    key: "copy",
    value: function copy(params, callback) {
      this.api(params, callback, 'PUT', 'copy');
    }
  }, {
    key: "selectAllMemberships",
    value: function selectAllMemberships(params, callback) {
      this.api(params, callback, 'POST', 'selectAllMemberships');
    }
  }, {
    key: "clearAllMemberships",
    value: function clearAllMemberships(params, callback) {
      this.api(params, callback, 'DELETE', 'clearAllMemberships');
    }
  }, {
    key: "testNotification",
    value: function testNotification(params, callback) {
      this.api(params, callback, 'POST', 'testNotification');
    }
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new NotificationAnnouncementStore();